import { createConnectQueryKey, useQuery, UseQueryOptions } from "@connectrpc/connect-query";

import {
  ListSourceSyncOperationsRequest,
  ListSourceSyncOperationsResponse,
} from "@gx/ts-contracts/services/source/api/source_sync_operation_pb";
import { listSourceSyncOperations } from "@gx/ts-contracts/services/source/api/source_sync_operation-SourceSyncOperationService_connectquery";

// ========== LIST SOURCE SYNCS OPERATIONS ==========

export const createListSourceSyncOperationsQueryKey = (input: ListSourceSyncOperationsRequest) => {
  return createConnectQueryKey({
    schema: listSourceSyncOperations,
    input,
    cardinality: "finite",
  });
};

export const useListSourceSyncOperationsQuery = ({
  input,
  options = {},
}: {
  input: ListSourceSyncOperationsRequest;
  options?: UseQueryOptions<
    typeof listSourceSyncOperations.output,
    ListSourceSyncOperationsResponse
  >;
}) => {
  return useQuery<typeof listSourceSyncOperations.input, typeof listSourceSyncOperations.output>(
    listSourceSyncOperations,
    input,
    options,
  );
};
